var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flow',_vm._b({},'Flow',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }